import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: grid;
  grid-template-columns: 3fr repeat(4, 1fr);
  background: #40bac9;
  margin-top: 8px;
`
const Value = styled.span`
  text-align: center;
  padding: 16px 8px;
  font-weight: bold;
  color: white;
  text-align: left;
`

const DebtFooter = ({ left, right, title, marginTop }) => (
  <Container marginTop={marginTop}>
    <Value>{title}</Value>
    <Value>{left}</Value>
    <Value>{right}</Value>
  </Container>
)

export default DebtFooter
